/*
 * 品种管理Verity
 * */
import request from './.request'

/**
 * 根据名称模糊查询
 * @param {string} name 
 * @returns 
 */
export function getVarietiesByName(name) {
  return request({
    url: `/variety?by=name&name=${name || ''}`,
    method: 'get',
  })
}

/**
 * 【注意】应该是多条件查询，待完善
 * @param {*} name 
 * @returns 
 */
export function verityNameSearch(name) {
  return request({
    url: '/variety/' + name,
    method: 'get',
    params: {
      by: 'name'
    }
  })
}
/**
 * 多条件过滤查询品种
 * @param {object} filter 多个查询条件的集合，见接口文档
 * @returns 
 */
export function getVarieties(filter) {
  return request({
    url: `/variety`,
    method: 'get',
    params: filter
  })
}

/**
 * 新增品种
 * @param {object} data 新增品种的参数，见接口文档
 * @returns 
 */
export function addVariety(data) {
  return request({
    url: '/variety',
    method: 'post',
    data: data
  })
}

/**
 * 更新品种
 * @param {number} id 品种id 
 * @param {object} data 品种新的参数集合，详见接口文档
 * @returns 
 */
export function updateVariety(id, data) {
  return request({
    url: `/variety/${id}`,
    method: 'put',
    data: data
  })
}

/**
 * 删除品种
 * @param {number} id 品种id
 * @returns 
 */
export function deleteVariety(id) {
  return request({
    url: `/variety/${id}`,
    method: 'delete',
  })
}



// WEBPACK FOOTER //
// ./src/api/variety.js